import React from 'react';
import { Chip } from '@mui/material';

const STATUS_COLORS = {
  Approved: 'success',
  Declined: 'error',
  Pending: 'warning',
};

const StatusChip = ({ status, icon = null }) => (
  <Chip
    icon={icon}
    label={status}
    size='small'
    color={STATUS_COLORS[status] || 'default'}
    sx={{ minWidth: '85px', justifyContent: 'center', borderRadius: '9999px', py: '4px' }}
  />
);

export default StatusChip;
